import { Card, Header } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { db } from "astrid-firebase";
import distributionStatuses from "astrid-firestore/src/api/distribution/constants/distributionStatuses";
import useBucket from "astrid-hooks/src/useBucket";

import CollectionDataTable from "../../../ui/components/CollectionDataTable/CollectionDataTable";
import FileDownloadModal from "../../../ui/components/FileDownload/FileDownloadModal";

import CreateExportButton from "../../../exports/components/CreateExportForm/CreateExportButton";

import useExportsTableColumns from "./hooks/useExportsTableColumns";

export default function ArtifactExportsView({ article, artifact, publisher }) {
	const { t } = useTranslation();

	const [downloadModal, setDownloadModal] = useState(false);
	const columns = useExportsTableColumns();
	const { downloadFolder } = useBucket("earselect-exports");

	return (
		<>
			<Header as="h3">{t("exports", "Exports")}</Header>

			<>
				<CollectionDataTable
					columns={columns}
					onClick={(theExport) => {
						if (theExport.status === distributionStatuses.COMPLETED) {
							setDownloadModal(theExport);
						}
					}}
					query={db
						.collection("exports")
						.where("artifact.ref", "==", artifact.ref)
						.where("deleted", "==", false)
						.orderBy("created", "asc")
						.limit(10)}
				/>

				<Card.Content>
					<CreateExportButton article={article} artifact={artifact} publisher={publisher} />
				</Card.Content>
			</>

			{downloadModal && (
				<FileDownloadModal
					filesOrFolder={downloadModal.id}
					downloadFn={downloadFolder}
					infoText={downloadModal.name}
					onClose={() => setDownloadModal(false)}
				/>
			)}
		</>
	);
}
